import React from 'react';
import ServerInfo from './ServerInfo';
import TestHistory from './TestHistory';
import SpeedGuide from './SpeedGuide ';
import PackageRecommendation from './PackageRecommendation ';

const Sidebar = ({ 
  serverInfo, 
  setServerInfo,
  testHistory, 
  showHistory, 
  setShowHistory, 
  results, 
  currentPhase 
}) => {
  return (
    <div className="space-y-6">
      <ServerInfo serverInfo={serverInfo} setServerInfo={setServerInfo} />
      <TestHistory 
        testHistory={testHistory} 
        showHistory={showHistory} 
        setShowHistory={setShowHistory} 
      />
      <SpeedGuide />
      <PackageRecommendation results={results} currentPhase={currentPhase} />
    </div>
  );
};

export default Sidebar;